import { colors } from '../../Colors/colors'

export const colorTheme = {
   light: {
      GRAY: {
         bgColor: 'bg-gray-100',
         borderColor: 'border-gray-600',
         textColor: 'text-gray-700',
         withOutBorderIconColor: colors['gray-500'],
         withBorderIconColor: colors['gray-600'],
         withOutBorderDotColor: 'bg-gray-500',
         withBorderDotColor: 'bg-gray-600',
         fillColor: colors['gray-600']
      },
      PRIMARY: {
         bgColor: 'bg-primary-50',
         borderColor: 'border-primary-600',
         textColor: 'text-primary-700',
         withOutBorderIconColor: colors['primary-500'],
         withBorderIconColor: colors['primary-600'],
         withOutBorderDotColor: 'bg-primary-500',
         withBorderDotColor: 'bg-primary-600',
         fillColor: colors['primary-600']
      },
      ERROR: {
         bgColor: 'bg-error-50',
         borderColor: 'border-error-600',
         textColor: 'text-error-700',
         withOutBorderIconColor: colors['error-500'],
         withBorderIconColor: colors['error-600'],
         withOutBorderDotColor: 'bg-error-500',
         withBorderDotColor: 'bg-error-600',
         fillColor: colors['error-600']
      },
      SUCCESS: {
         bgColor: 'bg-success-50',
         borderColor: 'border-success-600',
         textColor: 'text-success-700',
         withOutBorderIconColor: colors['success-500'],
         withBorderIconColor: colors['success-600'],
         withOutBorderDotColor: 'bg-success-500',
         withBorderDotColor: 'bg-success-600',
         fillColor: colors['success-600']
      },
      WARNING: {
         bgColor: 'bg-warning-50',
         borderColor: 'border-warning-600',
         textColor: 'text-warning-700',
         withOutBorderIconColor: colors['warning-500'],
         withBorderIconColor: colors['warning-600'],
         withOutBorderDotColor: 'bg-warning-500',
         withBorderDotColor: 'bg-warning-600',
         fillColor: colors['warning-600']
      },
      PURPLE: {
         bgColor: 'bg-purple-50',
         borderColor: 'border-purple-600',
         textColor: 'text-purple-700',
         withOutBorderIconColor: colors['purple-500'],
         withBorderIconColor: colors['purple-500'],
         withOutBorderDotColor: 'bg-purple-500',
         withBorderDotColor: 'bg-purple-600'
      },
      BLUE: {
         bgColor: 'bg-blue-50',
         borderColor: 'border-blue-600',
         textColor: 'text-blue-700',
         withOutBorderIconColor: colors['blue-500'],
         withBorderIconColor: colors['blue-500'],
         withOutBorderDotColor: 'bg-blue-500',
         withBorderDotColor: 'bg-blue-600',
         fillColor: colors['blue-600']
      },
      BLUE_DARK: {
         bgColor: 'bg-blue-dark-50',
         borderColor: 'border-blue-dark-600',
         textColor: 'text-blue-dark-700',
         withOutBorderIconColor: colors['blue-dark-500'],
         withBorderIconColor: colors['blue-dark-500'],
         withOutBorderDotColor: 'bg-blue-dark-500',
         withBorderDotColor: 'bg-blue-dark-600',
         fillColor: colors['blue-dark-600']
      },
      BLUE_LIGHT: {
         bgColor: 'bg-blue-light-50',
         borderColor: 'border-blue-light-600',
         textColor: 'text-blue-light-700',
         withOutBorderIconColor: colors['blue-light-500'],
         withBorderIconColor: colors['blue-light-500'],
         withOutBorderDotColor: 'bg-blue-light-500',
         withBorderDotColor: 'bg-blue-light-600',
         fillColor: colors['blue-light-500']
      },
      CYAN: {
         bgColor: 'bg-cyan-50',
         borderColor: 'border-cyan-600',
         textColor: 'text-cyan-700',
         withOutBorderIconColor: colors['cyan-500'],
         withBorderIconColor: colors['cyan-500'],
         withOutBorderDotColor: 'bg-cyan-500',
         withBorderDotColor: 'bg-cyan-600',
         fillColor: colors['cyan-500']
      },
      FUCHSIA: {
         bgColor: 'bg-fuchsia-50',
         borderColor: 'border-fuchsia-600',
         textColor: 'text-fuchsia-700',
         withOutBorderIconColor: colors['fuchsia-500'],
         withBorderIconColor: colors['fuchsia-500'],
         withOutBorderDotColor: 'bg-fuchsia-500',
         withBorderDotColor: 'bg-fuchsia-600',
         fillColor: colors['fuchsia-500']
      },
      GREEN: {
         bgColor: 'bg-green-50',
         borderColor: 'border-green-600',
         textColor: 'text-green-700',
         withOutBorderIconColor: colors['green-500'],
         withBorderIconColor: colors['green-500'],
         withOutBorderDotColor: 'bg-green-500',
         withBorderDotColor: 'bg-green-600',
         fillColor: colors['green-500']
      },
      GREEN_LIGHT: {
         bgColor: 'bg-green-light-50',
         borderColor: 'border-green-light-600',
         textColor: 'text-green-light-700',
         withOutBorderIconColor: colors['green-light-500'],
         withBorderIconColor: colors['green-light-500'],
         withOutBorderDotColor: 'bg-green-light-500',
         withBorderDotColor: 'bg-green-light-600',
         fillColor: colors['green-light-500']
      },
      INDIGO: {
         bgColor: 'bg-indigo-50',
         borderColor: 'border-indigo-600',
         textColor: 'text-indigo-700',
         withOutBorderIconColor: colors['indigo-500'],
         withBorderIconColor: colors['indigo-500'],
         withOutBorderDotColor: 'bg-indigo-500',
         withBorderDotColor: 'bg-indigo-600',
         fillColor: colors['indigo-500']
      },
      MOSS: {
         bgColor: 'bg-moss-50',
         borderColor: 'border-moss-600',
         textColor: 'text-moss-700',
         withOutBorderIconColor: colors['moss-500'],
         withBorderIconColor: colors['moss-500'],
         withOutBorderDotColor: 'bg-moss-500',
         withBorderDotColor: 'bg-moss-600',
         fillColor: colors['moss-500']
      },
      ORANGE: {
         bgColor: 'bg-orange-50',
         borderColor: 'border-orange-600',
         textColor: 'text-orange-700',
         withOutBorderIconColor: colors['orange-500'],
         withBorderIconColor: colors['orange-500'],
         withOutBorderDotColor: 'bg-orange-500',
         withBorderDotColor: 'bg-orange-600',
         fillColor: colors['orange-500']
      },
      ORANGE_DARK: {
         bgColor: 'bg-orange-dark-50',
         borderColor: 'border-orange-dark-600',
         textColor: 'text-orange-dark-700',
         withOutBorderIconColor: colors['orange-dark-500'],
         withBorderIconColor: colors['orange-dark-500'],
         withOutBorderDotColor: 'bg-orange-dark-500',
         withBorderDotColor: 'bg-orange-dark-600',
         fillColor: colors['orange-dark-500']
      },
      PINK: {
         bgColor: 'bg-pink-50',
         borderColor: 'border-pink-600',
         textColor: 'text-pink-700',
         withOutBorderIconColor: colors['pink-500'],
         withBorderIconColor: colors['pink-500'],
         withOutBorderDotColor: 'bg-pink-500',
         withBorderDotColor: 'bg-pink-600',
         fillColor: colors['pink-500']
      },
      ROSE: {
         bgColor: 'bg-rose-50',
         borderColor: 'border-rose-600',
         textColor: 'text-rose-700',
         withOutBorderIconColor: colors['rose-500'],
         withBorderIconColor: colors['rose-500'],
         withOutBorderDotColor: 'bg-rose-500',
         withBorderDotColor: 'bg-rose-600',
         fillColor: colors['rose-500']
      },
      TEAL: {
         bgColor: 'bg-teal-50',
         borderColor: 'border-teal-600',
         textColor: 'text-teal-700',
         withOutBorderIconColor: colors['teal-500'],
         withBorderIconColor: colors['teal-500'],
         withOutBorderDotColor: 'bg-teal-500',
         withBorderDotColor: 'bg-teal-600',
         fillColor: colors['teal-600']
      },
      VIOLET: {
         bgColor: 'bg-violet-50',
         borderColor: 'border-violet-600',
         textColor: 'text-violet-700',
         withOutBorderIconColor: colors['violet-500'],
         withBorderIconColor: colors['violet-500'],
         withOutBorderDotColor: 'bg-violet-500',
         withBorderDotColor: 'bg-violet-600',
         fillColor: colors['violet-600']
      },
      YELLOW: {
         bgColor: 'bg-yellow-50',
         borderColor: 'border-yellow-600',
         textColor: 'text-yellow-700',
         withOutBorderIconColor: colors['yellow-500'],
         withBorderIconColor: colors['yellow-500'],
         withOutBorderDotColor: 'bg-yellow-500',
         withBorderDotColor: 'bg-yellow-600',
         fillColor: colors['yellow-600']
      }
   },
   dark: {}
}
